var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrorUpDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5301 14.3057L5.53553 2.33748L7.77489 4.57269C7.90335 4.70466 8.07941 4.77911 8.26347 4.77911C8.87092 4.774 9.16938 4.03745 8.73639 3.6115L5.32911 0.200377C5.06261 -0.0667614 4.63026 -0.0667614 4.36377 0.200377L0.956796 3.6115C0.289589 4.2557 1.28273 5.24373 1.92341 4.57269L4.17236 2.32406L4.16693 14.3057C4.16021 14.6901 4.47241 15.0039 4.8565 15C5.23516 14.9975 5.53745 14.6843 5.5301 14.3057Z",
    fill: "#C3A0CD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrorUpDown);
export default __webpack_public_path__ + "static/media/arrorUpDown.a106284f917852039fc747f865d21786.svg";
export { ForwardRef as ReactComponent };